import { Button } from "primereact/button"
import gpraStyles from "../../styles/Participant-GPRA.module.css"
import GpraHistory from "./History/GpraHistory"
import StatusCard from "./StatusCard"
import InterviewCard from "./Interview-card"
import { useContext } from "react"
import { UserContext } from "../../context/userContext"

const GpraMain = ({
  setShowGpraHistory,
  showGpraHistory,
  interviewStatus,
  setReloadStatus,
  inactiveParticipant,
  loadingStatus,
  checkDate,
  blocked,
  updateUrl,
  setEditMode,
  clearContext,
}) => {
  const userCtx = useContext(UserContext)
  return (
    <>
      <h1>GPRA</h1>
      <div className={gpraStyles.viewHistoryButtonContainer}>
        <Button
          label="View GPRA History"
          onClick={() => {
            setShowGpraHistory(true)
          }}
        />
        <GpraHistory
          visible={showGpraHistory}
          setVisible={setShowGpraHistory}
        />
      </div>
      <StatusCard
        gpra_record={interviewStatus?.gpraRecord}
        ableToDelete={interviewStatus?.ableToDelete}
        setReloadStatus={setReloadStatus}
        ableToCreate={interviewStatus?.ableToCreate}
        inactiveParticipant={inactiveParticipant()}
        membership_uuid={userCtx.participant_membership_id}
        participant_id={userCtx.participant_alias}
        participant_uuid={userCtx.current_participant_id}
        organization_alias={userCtx.session.user.organization_alias}
        organization_id={userCtx.session.user.organization_id}
        organization_name={userCtx.session.user.organization_name}
        participant_name={`${userCtx.participant_name_first} ${userCtx.participant_name_last}`}
        program_list={userCtx.program_list}
        staff_id={userCtx.session.user.staff_id}
        startedIntake={interviewStatus?.intakeStarted}
        startedFollowUp={interviewStatus?.followUpStarted}
        startedDischarge={interviewStatus?.dischargeStarted}
        completedIntake={interviewStatus?.intakeCompleted}
        completedFollowUp={interviewStatus?.followUpCompleted}
        completedDischarge={interviewStatus?.dischargeCompleted}
        dischargeStartDate={interviewStatus?.dischargeStartDate}
        recordStatus={interviewStatus?.recordStatus}
        blocked={blocked}
      />
      <InterviewCard
        loadingStatus={loadingStatus}
        key={"intake"}
        completed={interviewStatus?.intakeCompleted}
        availability_date={checkDate(interviewStatus?.intakeAvailability)}
        completed_date={checkDate(interviewStatus?.intakeCompletedDate)}
        due_date={checkDate(interviewStatus?.intakeDueDate)}
        title="Intake"
        type="Intake"
        updateUrl={updateUrl}
        inactiveParticipant={inactiveParticipant()}
        started={interviewStatus?.intakeStarted}
        blocked={blocked}
        start_date={checkDate(interviewStatus?.intakeStartDate)}
        clearContext={clearContext}
        setEditMode={setEditMode}
        creator_staff_id={interviewStatus?.intakeStaffId}
      />
      <InterviewCard
        loadingStatus={loadingStatus}
        key={"followUp"}
        completed={interviewStatus?.followUpCompleted}
        availability_date={checkDate(interviewStatus?.followUpAvailability)}
        completed_date={checkDate(interviewStatus?.followUpCompletedDate)}
        due_date={checkDate(interviewStatus?.followUpDueDate)}
        close_date={checkDate(interviewStatus?.followUpCloseDate)}
        title="Follow Up"
        type="FollowUp"
        updateUrl={updateUrl}
        inactiveParticipant={inactiveParticipant()}
        started={interviewStatus?.followUpStarted}
        blocked={blocked}
        start_date={checkDate(interviewStatus?.followUpStartDate)}
        clearContext={clearContext}
        setEditMode={setEditMode}
        creator_staff_id={interviewStatus?.followUpStaffId}
      />
      <InterviewCard
        loadingStatus={loadingStatus}
        key={"discharge"}
        completed={interviewStatus?.dischargeCompleted}
        availability_date={checkDate(interviewStatus?.dischargeAvailability)}
        completed_date={checkDate(interviewStatus?.dischargeCompletedDate)}
        due_date={checkDate(interviewStatus?.dischargeDueDate)}
        title="Discharge"
        type="Discharge"
        updateUrl={updateUrl}
        inactiveParticipant={inactiveParticipant()}
        blocked={blocked}
        start_date={checkDate(interviewStatus?.dischargeStartDate)}
        clearContext={clearContext}
        setEditMode={setEditMode}
        creator_staff_id={interviewStatus?.dischargeStaffId}
      />
    </>
  )
}
export default GpraMain
